import React from 'react';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer';
import AffordabilityCalculator from '../../components/affordability-calculator';

const AffordabilityCalculatorPage: React.FC = () => {
    return (
        <div className="bg-slate-50 min-h-screen">
            <Navbar transparent={false} />
            
            {/* Page Header */}
            <div className="relative pt-6 md:pt-10 pb-6 md:pb-10 bg-white border-b border-slate-100 overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full opacity-5">
                    <div className="absolute top-10 left-10 w-64 h-64 bg-[#001b4a] rounded-full blur-3xl"></div>
                    <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#f1ae24] rounded-full blur-3xl"></div>
                </div>
                
                <div className="container px-6 relative z-10">
                    <div className="max-w-4xl">
                        <nav className="flex items-center gap-2 text-slate-400 text-xs font-medium tracking-wide mb-1 md:mb-2">
                            <span>Tools</span>
                            <i className="fa-solid fa-chevron-right text-[8px]"></i>
                            <span className="text-[#001b4a]">Affordability Calculator</span>
                        </nav>
                        
                        <h1 className="text-3xl md:text-5xl font-bold text-[#001b4a] mb-2 md:mb-4 leading-tight">
                            Home <span className="text-[#f1ae24]">Affordability</span> Guide
                        </h1>
                        <p className="text-slate-500 text-base font-medium max-w-2xl leading-relaxed">
                            Discover your real home-buying potential. Our advanced engine analyzes your income, savings, and obligations to calculate exactly how much house you can comfortably afford.
                        </p>
                    </div>
                </div>
            </div>

            <section className="py-6 md:py-8 -mt-10 relative z-20">
                <div className="container px-6">
                    <div className="max-w-6xl mx-auto">
                        <AffordabilityCalculator initialSalary={100000} />
                        
                        {/* Summary / Educational Content Below Tool */}
                        <div className="mt-8 md:mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
                            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
                                <div className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center text-[#001b4a] mb-4">
                                    <i className="fa-solid fa-calculator text-lg"></i>
                                </div>
                                <h5 className="font-bold text-slate-900 text-sm mb-3">How it works?</h5>
                                <p className="text-slate-500 text-sm leading-relaxed">
                                    Affordability is calculated using the FOIR (Fixed Obligation to Income Ratio) method. Banks typically allow up to 50% of your net monthly income to be used for all loan repayments combined.
                                </p>
                            </div>
                            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
                                <div className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center text-[#001b4a] mb-4">
                                    <i className="fa-solid fa-piggy-bank text-lg"></i>
                                </div>
                                <h5 className="font-bold text-slate-900 text-sm mb-3">Maximize Eligibility</h5>
                                <p className="text-slate-500 text-sm leading-relaxed">
                                    To increase your borrowing power, try clearing existing small loans, adding a co-applicant (like a spouse) with a steady income, or choosing a longer loan tenure to reduce the monthly EMI.
                                </p>
                            </div>
                            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
                                <div className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center text-[#001b4a] mb-4">
                                    <i className="fa-solid fa-shield-halved text-lg"></i>
                                </div>
                                <h5 className="font-bold text-slate-900 text-sm mb-3">Smart Budgeting</h5>
                                <p className="text-slate-500 text-sm leading-relaxed">
                                    While the calculator shows your maximum limit, it's wise to leave a buffer for unexpected expenses. Aim for an EMI that allows you to maintain your lifestyle comfortably.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <Footer />
        </div>
    );
};

export default AffordabilityCalculatorPage;
